import { Autocomplete, TextField } from "@mui/material"
import React from "react"
import { IOption } from "ui/model"

interface IAutoCompleteSelectProps<T extends string | number | null> {
  id: string
  label: string
  filters: T[]
  value: T[]
  freeSolo?: boolean
  placeholder?: string
  sx?: any
  optionLabelFn(value: T): string
  onChange(newValue: T[]): any
}

export const AutoCompleteSelect = React.memo(
  ({
    id,
    label,
    filters,
    value,
    freeSolo,
    placeholder,
    sx,
    optionLabelFn,
    onChange
  }: IAutoCompleteSelectProps<string | number | null>): JSX.Element => {
    let options: IOption[] = filters.map(f => ({ value: f, label: optionLabelFn(f) || "-" }))
    options = options.sort((a, b) => -b.label.localeCompare(a.label))
    return (
      <Autocomplete
        multiple
        sx={{ "& input::placeholder": { fontSize: ".7rem" }, ...sx }}
        size="small"
        freeSolo={freeSolo || false}
        id={id}
        options={options}
        value={value !== null ? options.filter(o => value.contains(o.value)) : []}
        filterSelectedOptions
        onChange={(_event, newValue) => onChange(newValue.map(v => (v as IOption).value))}
        renderInput={params => <TextField {...params} label={label} placeholder={placeholder} />}
      />
    )
  }
)
